export const MUTATION_OBSERVER_OPTIONS = {
    subtree: true,
    attributes: true,
    childList: true,
    characterData: false,
    characterDataOldValue: false
};

export const FINANCING_OPTIONS_AVAILABLE_TERMS = [12, 24, 36];
export const LEASING_OPTIONS_AVAILABLE_TERMS = [30, 60];
export const FINANCING_MONTHLY_RATE_DEFAULT = 4.99;
export const SELECTORS = {
    initializer: "[data-rate-calculator]",
    container: ".rate-calculator",
    financingFrom: ".financing-from",
    leasingFrom: ".leasing-from",
    button: "[data-calculator-open]",
    tabbed: "dialog .rate-calculator-modal .tabbed",
    tabFinancing: "#tab-financing",
    tabLeasing: "#tab-leasing"
};
